import { NotificationProps } from '@mantine/core';

import classes from './Notification.module.css';

export const NotificationDefaultProps: Partial<NotificationProps> = {
  withBorder: true,
  radius: 'sm',
  classNames: classes
};
